import { Bubble } from "./Bubble";

export { InvalidBubble };

function InvalidBubble() {
  return <Bubble className="Invalid" text={"Invalid"} />;
}
